module.exports = __webpack_public_path__ + "ck.svg?e697f1d6abb7428144013869667caa87";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ck.svg
// module id = 1027
// module chunks = 27